import { PagedSearch } from '../../../shared/index';

export class ContactTypeSearchParams extends PagedSearch {
  public Keyword: string;
  public DateCreatedStart: Date;
  public DateCreatedEnd: Date;
  public DateChangedStart: Date;
  public DateChangedEnd: Date;

  public constructor() {
    super();

    this.Keyword = '';
    this.DateCreatedStart = new Date();
    this.DateCreatedEnd = new Date();
    this.DateChangedStart = new Date();
    this.DateChangedEnd = new Date();
  }
}
